module.exports = __webpack_public_path__ + "img/keepfee.7ee7256c.png";